import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppBarTitleService, AppBarTitleComponentData } from 'common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifp-app-bar-title',
    templateUrl: './app-bar-title.component.html',
    styleUrls: ['./app-bar-title.component.scss'],
    standalone: false
})
export class AppBarTitleComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private service: AppBarTitleService) {
  }

  data: AppBarTitleComponentData;

  dataSet(data: AppBarTitleComponentData) {
    this.data = data;
    if (data.appBarTitle)
      this.title = data.appBarTitle.content;
  }

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this)).subscribe(this.dataSet.bind(this));
    this.service.titleChange.pipe(untilDestroyed(this)).subscribe(it => this.title = it);
  }

  title: string;

}
